import { Box, Chip, Typography } from "@mui/material";
import React from "react";
import { IHobby } from "store/types/user/social";

interface IHobbiesProps {
  data: IHobby[];
}

export const Hobbies: React.FC<IHobbiesProps> = ({ data }) => {
  if (!data.length) return null;

  return (
    <Box sx={{ width: "100%" }}>
      <Typography sx={{ color: "#0a3142", fontSize: "16px", fontWeight: "500", marginBottom: "17px" }}>
        Hobbies
      </Typography>
      <Box display="flex" flexWrap="wrap" gap="10px" sx={{ width: "100%" }}>
        {data.map((hobby) => {
          return (
            <Chip
              sx={{
                backgroundColor: "#26a6ae",
                color: "#ffffff",
                fontSize: "14px",
                padding: "16px 5px",
                ".MuiChip-label": {
                  overflow: "visible"
                }
              }}
              key={hobby.id}
              label={hobby.title}
            />
          );
        })}
      </Box>
    </Box>
  );
};
